import { axiosPost } from '../ServiceBase.js';

export const buscarReintegros = async (data) => {
  const reintegros = await axiosPost('/v1/busquedas/buscarReintegros', data);
  return reintegros;
};
